export enum TabId {
  Features = 0,
  Solutions = 1,
  Plans = 2,
  Pricing = 3,
  Resources = 4,
}
